import { TeamMemberRole } from '@api'
import { useUnit } from 'effector-react'

import PlusIcon from '@/assets/icons/icon-plus.svg'
import { Button } from '@/components/ui/button'
import { SearchInput } from '@/components/ui/search-input'
import { $account } from '@/models/account.ts'

interface Props {
  onCreateNew: () => void
  onSearch: (value: string) => void
}

export const TeamRoleHeaderActions = ({ onCreateNew, onSearch }: Props) => {
  const account = useUnit($account)

  return (
    <div className="flex items-center gap-2">
      <SearchInput
        placeholder="Search"
        onInputChange={onSearch}
      />
      {account?.memberRole !== TeamMemberRole.MEMBER && (
        <Button
          onClick={onCreateNew}
          className="flex gap-1"
        >
          <PlusIcon
            width={25}
            height={25}
          />
          Create new Role
        </Button>
      )}
    </div>
  )
}
